import type { ReactNode } from "react"

type StepProps = {
  title?: string
  index?: number
  children?: ReactNode
  last?: boolean
}

export const Step = ({ title, index, children, last }: StepProps) => {
  return (
    <section className="relative pb-8 pr-4">
      <header className="flex items-center gap-4">
        <div className={`absolute w-[1.5px] bottom-[-13px] top-[50px] left-[16.75px] ${last ? "bg-gradient-to-b from-primary/10 to-primary/0" : "bg-primary/10"} rounded-full`}/>
        <span className="flex size-9 items-center justify-center rounded-full bg-primary/10 text-md font-semibold text-primary"  style={{ outline: 'solid 10px var(--background)' }}>{index}</span>
        {/* <h2 className="text-xl font-semibold leading-tight text-foreground translate-x-[-2px]">{title}</h2> */}
        <h2 className="text-xl font-semibold leading-tight text-foreground translate-x-[1px]">{title}</h2>
      </header>
      {/* <div className="mt-4 space-y-6 pl-[52px]"> */}
      <div className="mt-4 space-y-6 pl-[56px]">
        {children}
      </div>
    </section>
  )
}
